module.exports = __webpack_public_path__ + "static/media/icon-x.40a39e33.svg";